<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3 checklistTempTab"
                        :data="tabData"
                        activeKey="basic_info">
                    <template slot="gofixTab:basic_info">
                        <gofix-card class="mb-0" fullContent>
                            <gofix-table :settings="tableConfig"
                                :table-items="tableItems"
                                @load-items="getTableData"
                                ref="gofixTable">
                                <template slot="gofix_table:created_at" slot-scope="row">
                                    {{ row.item.created_at | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
                                </template>
                                <template slot="gofix_table:actual_amount" slot-scope="row">
                                    {{ row.item.actual_amount | formatMoney }}
                                </template>
                                <template slot="gofix_table:committed_amount" slot-scope="row">
                                    {{ row.item.committed_amount | formatMoney }}
                                </template>
                            </gofix-table>
                        </gofix-card>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>

    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js';

    export default {
        name: 'budget-tracking-detail-info',
        components: {},
        data() {
            let filter = JSON.parse(JSON.stringify(filters['budget_tracking_detail']));
            return {
                tabData:[
                    {
                        key: "basic_info",
                        title: "Basic Info",
                        active: true
                    }
                ],
                tableItems: [],
                tableConfig:{
                    name: 'budget-entries',
                    controls:{
                        create: false,
                        delete: false,
                        tableImport: false,
                        tableExport: false,
                        tableColumnSettings: false
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    fields: [
                        {
                            key: 'budget_referable_number',
                            label: 'Document Number',
                            thStyle: "width:150px",
                            isActive: 1,
                            isFilter: true,
                            sorting: true
                        },
                        {
                            key: 'budget_referable_type',
                            label: 'Document Type',
                            thStyle: "width:120px",
                            isActive: 1,
                            isFilter: true,
                            sorting: true
                        },
                        {
                            key: 'fm_code',
                            label: 'FM Code',
                            thStyle: "width:120px",
                            isActive: 1,
                            isFilter: true,
                            sorting: true
                        },
                        {
                            key: 'gl_code',
                            label: 'GL Code',
                            thStyle: "width:120px",
                            isActive: 1,
                            isFilter: true,
                            sorting: true
                        },
                        {
                            key: 'created_at',
                            label: 'Date',
                            isActive: 1,
                            thStyle: "width:80px",
                            isFilter: true,
                            sorting: true
                        },
                        {
                            key: 'committed_amount',
                            label: 'Committed Amount',
                            thClass: "text-right pr-4",
                            tdClass: "text-right pr-3",
                            isActive: 1,
                            thStyle: "width:120px",
                            isFilter: true,
                            sorting: true
                        },
                        {
                            key: 'actual_amount',
                            label: 'Actual Amount',
                            thClass: "text-right pr-4",
                            tdClass: "text-right pr-3",
                            isActive: 1,
                            thStyle: "width:120px",
                            isFilter: true,
                            sorting: true
                        }
                    ]
                },
            }
        },
        computed: {
            ...mapGetters({
                HeaderItem: 'BudgetAllocationController/headerItem',
            }),
        },
        created() {
        },
        methods: {
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.budget_header_id.value = this.$route.params.id;
                tableRequest.filter.fm_code_id.value = this.$route.query.fm_code;
                tableRequest.filter.calendar_month.value = this.$route.query.calendar_month;
                await this.$store.dispatch("BudgetAllocationController/getBudgetTrackingDetailEntries", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            },
        }
    }
</script>
